
import axios from 'axios';
export const PASARELA = process.env.VUE_APP_URLPASARELA;
export const Medios = {
  // Consultar estado de app. Mantenimiento
  getMediosPago() {
    return axios.get(PASARELA + "/checkout/tarjetas/all")
  },
}
